<template>
	<div class="app-container">
	  <router-view />
	</div>
</template>

<script>
export default {
  name: 'Lease'
}
</script>

<style>
</style>
